// Using react-hot-toast with custom styling
import React from 'react';
import { toast } from 'react-hot-toast';
import { AlertCircle, Info, CheckCircle } from 'lucide-react';

export const showToast = {
    warning: (message: string) => {
        toast.custom((t) => (
            <div className="flex items-center gap-3 bg-amber-50 border border-amber-200 rounded-lg px-4 py-3 shadow-lg">
                <AlertCircle className="h-5 w-5 text-amber-500 flex-shrink-0" />
                <p className="text-sm text-amber-700">{message}</p>
            </div>
        ), { duration: 4000 });
    },
    error: (message: string) => {
        toast.custom((t) => (
            <div className="flex items-center gap-3 bg-red-50 border border-red-200 rounded-lg px-4 py-3 shadow-lg">
                <AlertCircle className="h-5 w-5 text-red-500 flex-shrink-0" />
                <p className="text-sm text-red-700">{message}</p>
            </div>
        ), { duration: 4000 });
    },
    info: (message: string) => {
        toast.custom((t) => (
            <div className="flex items-center gap-3 bg-blue-50 border border-blue-200 rounded-lg px-4 py-3 shadow-lg">
                <Info className="h-5 w-5 text-blue-500 flex-shrink-0" />
                <p className="text-sm text-blue-700">{message}</p>
            </div>
        ), { duration: 4000 });
    },
    success: (message: string) => {
        toast.custom((t) => (
            <div className="flex items-center gap-3 bg-green-50 border border-green-200 rounded-lg px-4 py-3 shadow-lg">
                <CheckCircle className="h-5 w-5 text-green-500 flex-shrink-0" />
                <p className="text-sm text-green-700">{message}</p>
            </div>
        ), { duration: 4000 });
    }
};

export default showToast;